export default __webpack_public_path__ + "static/media/lateral-line.5f8715c5.svg";